const toggle = document.querySelector("[data-toggle]");
const toggleButton = document.querySelector("[data-toggle-button]");
const toggleList = document.querySelector("[data-toggle-content]");

if (toggle && toggleButton && toggleList) {
  toggleButton.addEventListener("click", () => {
    toggle.classList.toggle("is-open");
    toggleList.classList.toggle("is-open");

    window.updateElementQueries();
  });
}
